/*
 *
 * MUTATION FILE: ONLY FOR STATE MODIFICATION
 * - RULES:
 *   - MUST NOT HAVE ANY BUSINESS LOGIC
 *   - CANNOT CONTAIN ANY ASYNC OR PROMISE -> NO API CALLS
 *
 */

/**
 * Modifica el langCode
 * @param {any} state
 * @param {any} langCodeAux
 */
export const langCode = function (state, langCodeAux) {
  state.langCode = langCodeAux;
};

/**
 * Modifica el translationIsLoaded
 * @param {any} state
 * @param {any} translationIsLoaded
 */
export const translationIsLoaded = function (state, translationIsLoaded) {
  state.translationIsLoaded = translationIsLoaded;
};

/**
 * Modifica el showApp
 * @param {any} state
 * @param {any} langCode
 */
export const showApp = function (state, showApp) {
  state.showApp = showApp;
};

/**
 * Setea las config del usuario en el store.
 * @param {any} state
 * @param {object} userSettings configuraciones del usuario.
 */
export const userSettings = function (state, userSettingsAux) {
  state.userSettings = userSettingsAux;
};

export const componentsActivation = function (state, components) {
  state.componentsActivation = components;
};

export const setMode = function (state, mode) {
  state.mode = mode;
};
